import { Box, BoxProps, useTheme } from '@chakra-ui/react'

interface ChartWrapperProps {
  children: React.ReactNode
  height?: number | string
}

const ChartWrapper = ({ children, ...rest }: ChartWrapperProps & BoxProps) => {
  const theme = useTheme()
  const shadowColor = theme.colors.mask.gray[700][20]

  return (
    <Box
      bg="gray.100"
      borderRadius="0.5rem"
      boxShadow={`0 2px 6px -1px ${shadowColor}`}
      p="1rem"
      width="100%"
      border="1px solid"
      borderColor="gray.400"
      {...rest}
    >
      {children}
    </Box>
  )
}

export default ChartWrapper
